import { getProduct } from "../../data";
import { formatDate, isSchedulePaused, nextDeliveryDate } from "../../utils/admin";
import { StatusBadge } from "../UI";

export default function ScheduleTable({ schedules, usersById, addressesById, empty = "No active schedules found." }) {
  if (!schedules.length) return <div className="admin-empty"><i className="fa-solid fa-repeat" /><strong>{empty}</strong><span>Recurring subscriptions will appear here.</span></div>;
  const now = new Date();
  return (
    <div className="admin-table-wrap">
      <table className="admin-table">
        <thead><tr><th>Customer</th><th>Product</th><th>Selected fruits</th><th>Type / Frequency</th><th>Days</th><th>Next delivery</th><th>Time</th><th>Address</th><th>Status</th></tr></thead>
        <tbody>
          {schedules.map((schedule) => {
            const user = usersById[schedule.userId];
            const address = addressesById[schedule.addressId];
            const next = nextDeliveryDate(schedule, now);
            const product = getProduct(schedule.productId);
            const isFruitBasket = schedule.type === "fruit_basket" || product?.type === "fruit_basket";
            const selectedFoods = Array.isArray(schedule.selectedFoods) ? schedule.selectedFoods : [];
            return <tr key={schedule.id}>
              <td><strong>{user?.name || "Unknown customer"}</strong><small>{user?.mobile || user?.email || "—"}</small></td>
              <td><strong>{product?.name || schedule.productId || "—"}</strong><small>{isFruitBasket ? "Fresh fruits" : "Natural shake"}</small></td>
              <td>{isFruitBasket ? (selectedFoods.length ? <div className="admin-selected-foods">{selectedFoods.map((food) => <span className="admin-selected-food" key={food}>{food}</span>)}</div> : <small>Not recorded</small>) : <small>—</small>}</td>
              <td><strong>{schedule.frequency || (schedule.days?.length ? "Recurring" : "One Time")}</strong></td><td>{schedule.days?.length ? schedule.days.join(", ") : "One time"}</td>
              <td><strong>{formatDate(next)}</strong><small>Starts {formatDate(schedule.startDate)}</small></td>
              <td>{schedule.deliveryTimeSlot || "—"}</td>
              <td><strong>{address?.area || "—"}</strong><small>{address?.line || "Pune"}</small></td>
              <td><StatusBadge status={schedule.status === "active" ? (isSchedulePaused(schedule, now) ? "Paused" : "Active") : schedule.status} /></td>
            </tr>;
          })}
        </tbody>
      </table>
    </div>
  );
}
